export const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

export const capitalizeWords = (string: string, acronym?: boolean) => {
  // CFA_SUPPLY --> CFA Supply
  if (acronym) {
    const words = string.split('_');
    return `${words[0]} ${words[1]?.charAt(0).toUpperCase()}${words[1]?.slice(1).toLowerCase()}`;
    // BAY_CENTER --> Bay Center
  } else {
    return string
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
};
